import React from 'react';
import {
    Paper,
    Typography,
    Box,
    Button,
    Avatar,
} from '@mui/material';
import {
    Edit as EditIcon,
    Call as CallIcon,
    LocationOn as LocationOnIcon,
    CalendarToday as CalendarTodayIcon,
} from '@mui/icons-material';

const OrderClientCard = ({ client, deliveryDate, onEdit }) => {
    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.split(' ');
        return (parts.length >= 2 ? parts[0][0] + parts[1][0] : name.substring(0, 2)).toUpperCase();
    };

    return (
        <Paper sx={{ p: 2.5, border: '1px solid #d0dbe7', borderRadius: '0.75rem' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography sx={{ fontWeight: 600, color: '#0e141b' }}>Datos del Cliente</Typography>
                {onEdit && (
                    <Button size="small" startIcon={<EditIcon />} onClick={onEdit} sx={{ color: '#1976d2', textTransform: 'none' }}>
                        Editar
                    </Button>
                )}
            </Box>

            {client ? (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                        <Avatar sx={{ bgcolor: '#1976d2', width: 48, height: 48 }}>{getInitials(client.name)}</Avatar>
                        <Box>
                            <Typography sx={{ fontWeight: 600 }}>{client.name}</Typography>
                            <Typography sx={{ fontSize: '0.875rem', color: '#4e7397' }}>Cliente Mayorista</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CallIcon sx={{ color: '#4e7397', fontSize: '1.25rem' }} />
                            <Typography sx={{ fontSize: '0.875rem' }}>{client.phone || 'N/A'}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                            <LocationOnIcon sx={{ color: '#4e7397', fontSize: '1.25rem', mt: 0.5 }} />
                            <Box>
                                <Typography sx={{ fontSize: '0.875rem' }}>
                                    {client.delivery_address}
                                </Typography>
                                <Typography sx={{ fontSize: '0.75rem', color: '#4e7397' }}>
                                    Ciudad Tango: {client.delivery_city_name || client.city}
                                </Typography>
                            </Box>
                        </Box>
                        {client.delivery_schedule?.routes?.length > 0 && (
                            <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                                {client.delivery_schedule.routes.map((r, idx) => (
                                    <Typography key={idx} sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#2e7d32', bgcolor: '#e8f5e9', px: 1, py: 0.25, borderRadius: '0.25rem' }}>
                                        Recorrido: {r.day_label} ({r.route_name})
                                    </Typography>
                                ))}
                            </Box>
                        )}
                    </Box>
                </>
            ) : (
                <Typography sx={{ color: '#4e7397' }}>Consumidor Final</Typography>
            )}

            {deliveryDate && (
                <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e7edf3' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CalendarTodayIcon sx={{ color: '#4e7397', fontSize: '1.25rem' }} />
                        <Box>
                            <Typography sx={{ fontSize: '0.75rem', color: '#4e7397', mb: 0.5 }}>Fecha de Entrega</Typography>
                            <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
                                {new Date(deliveryDate).toLocaleDateString('es-AR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            )}
        </Paper>
    );
};

export default OrderClientCard;
